/**
 * About-page contact form client (B-166, 2026-09-02).
 *
 *   POST /api/contact
 *
 * Public, unauthenticated. The api rate-limits per IP and carries a
 * honeypot field (`website`) the real form keeps hidden and empty.
 */

const base = () => process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";

export interface ContactBody {
  name: string;
  email: string;
  topic: string;
  message: string;
  /** Honeypot. The form renders it visually hidden; humans leave it empty. */
  website?: string;
}

export class ContactApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ContactApiError";
  }
}

export async function sendContactMessage(
  body: ContactBody,
): Promise<{ ok: boolean }> {
  const res = await fetch(`${base()}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new ContactApiError(
      res.status,
      `POST /api/contact returned ${res.status}`,
    );
  }
  return res.json();
}
